import { Button, Divider, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { deleteAccount, editProfile, editProfileBGImage, editProfileInfo } from '../../../actions/auth';
import theme from '../../../muiTheme';
import CustomInput from '../../Form/CustomInput';
import ImageUpload from '../../ImageUpload/ImageUpload';
import styles from './styles'; 

const EditAll = ({profile, onCompleted, isMobile}) => {

    //This will be an isolated component

    const dispatch = useDispatch(); 
    const navigate = useNavigate();
    const authStateSlice = useSelector((state) => state.authReducer);
    const [data, setData] = useState({
        userName: '',
        bio: '',
        location: '',
        email: '',
        website: '',
        profileQuote: '',
        profileImage: null, //will be uploaded separately, so it can be skipped if no change,
        profileBGImage: null, //will be uploaded separately, so it can be skipped if no change,
    });

    const [modifiedProfile, setModifiedProfile] = useState(profile); 
    const [newProfileImage, setNewProfileImage] = useState(null);
    const [newProfileBGImage, setNewProfileBGImage] = useState(null);
    const [bgAv, setBgAv] = useState({});

    useEffect(()=>{



        if(profile){

            console.log('Edit All Profile: ', profile);

            setData({
                userName: profile.name || '',
                bio: profile.bio || '',
                email: profile.email || null, 
                location: profile.location || '',
                website: profile.website || '',
                profileQuote: profile.profileQuote || '',
                profileImage: profile.profileImage || null,
                profileBackgroundImage: profile.profileBackgroundImage || null
            });

        }
        

    }, []);


    const onProfileImageSelected = (selectedFile) => {


        if(selectedFile){
            setNewProfileImage(selectedFile);

            setData({
                ...data,
                selectedFile: selectedFile
            });
        }
        
    }

    const onBGImageSelected = (selectedFile, avColors) => {


        if(selectedFile){
            setNewProfileBGImage(selectedFile);
            setBgAv(avColors);
        }
        
    }

    const onSubmit = ()=>{

        console.log('new profile image: ', newProfileImage);

        //append values to profile
        if(newProfileImage){

            //dispatch api call to change profile image along with everything else
            dispatch(editProfile(data, navigate, `/profile/${profile._id}`));

        } else {

            //dispatch call to update just the rest
            dispatch(editProfileInfo(data, navigate, `/profile/${profile._id}`));
        }

        //profile BG Image gets uploaded separately
        if(newProfileBGImage){
            dispatch(editProfileBGImage({email: profile.email, selectedFile: newProfileBGImage, avColors: bgAv}));
        }


    }

    const deleteProfile = () => {

        //ask user to confirm first

        if(profile._id){
            dispatch(deleteAccount(profile._id));
        }
        
    }

    return (
        <Box
            sx={styles.editAllContainer}
        >

            <Typography variant='h5' sx={{marginBottom: '20px', textAlign: 'center'}}>
                Edit  Profile
            </Typography>


            
            <Divider sx={{width: '90%', marginBottom: '20px'}}/>

            <Box
                sx={{
                    minWidth: '90%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    marginBottom: '10px', 
                }}
            >

                <Typography 
                    variant='body1' 
                    sx={{
                        // backgroundColor: theme.palette.primary.main,
                        // padding: '10px 20px',
                        // color: 'white',
                        // borderRadius: '60px'
                        }}>
                    Profile Image
                </Typography>
            </Box>
            
            

            <ImageUpload 
                sx={{marginBottom: '20px'}} 
                startingImage={profile.profileImage || null} 
                text='Select New' 
                previewSx={{borderRadius: '50%'}} 
                onSelected={onProfileImageSelected} 
                forceCrop={true}
                imageLabel=' '
                editButtonType='inline'
            />


            <Divider sx={{width: '90%', marginBottom: '20px'}}/>

            <Box
                sx={{
                    minWidth: '90%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    marginBottom: '10px', 
                }}
            >

                <Typography 
                    variant='body1' 
                    sx={{
                        // backgroundColor: theme.palette.primary.main,
                        // padding: '10px 20px',
                        // color: 'white',
                        // borderRadius: '60px'
                        }}>
                    Background Image
                </Typography>
            </Box>
            
            

            <ImageUpload 
                sx={{marginBottom: '20px'}} 
                startingImage={profile.profileBackgroundImage || null} 
                text='Select New' 
                previewSx={{
                    borderRadius: '20px',
                    maxWidth: '100%'
                }} 
                onSelected={onBGImageSelected} 
                forcedAspect={{
                    x: 7,
                    y: 4
                }}
                imageLabel=' '
                editButtonType='inline'
                editButtonSx={{top: '20px'}}
            />

            <Divider sx={{width: '90%', marginBottom: '20px'}}/>

            <Box
                sx={{
                    minWidth: '90%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    marginBottom: '30px', 
                }}
            >

                <Typography 
                    variant='body1' 
                    sx={{
                        // backgroundColor: theme.palette.primary.main,
                        // padding: '10px 20px',
                        // color: 'white',
                        // borderRadius: '60px'
                        }}>
                    A quote for your page
                </Typography>
            </Box>

            <CustomInput name="profileQuote" 
                variant='standard' 
                label="Your famous quote" 
                placeholder={'I like Turtles!'}
                required={false}
                fullWidth 
                characterLimit={200}
                characterLimitSx = {{
                    marginTop: '0px'
                }}
                multiline={false}
                value={data.profileQuote}
                handleChange={(e)=>setData({
                    ...data,
                    profileQuote: e.target.value
                })}

            />

            <Typography variant='body2' sx={{marginTop: '10px', marginLeft: '20px', alignSelf: 'flex-start'}}>
                Leave empty if you don't want a quote
            </Typography>


            <Divider sx={{width: '90%', marginBottom: '20px', marginTop: '20px'}}/>

            <Box
                sx={{
                    minWidth: '90%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    marginBottom: '30px', 
                }}
            >

                <Typography 
                    variant='body1' 
                    sx={{
                        // backgroundColor: theme.palette.primary.main,
                        // padding: '10px 20px',
                        // color: 'white',
                        // borderRadius: '60px'
                        }}>
                    Your details
                </Typography>
            </Box>

            <CustomInput name="userName" 
                variant='standard' 
                label="Your Name" 
                placeholder={'What will they call you?'}
                required={true}
                fullWidth 
                multiline={false}
                value={data.userName}
                handleChange={(e)=>setData({
                    ...data,
                    userName: e.target.value
                })}
            />


            <CustomInput name="description" 
                variant='standard' 
                label="Describe yourself" 
                placeholder={'Will you pass the vibe check?'}
                required={true}
                fullWidth 
                multiline={true}
                value={data.bio}
                handleChange={(e)=>setData({
                    ...data,
                    bio: e.target.value
                })}
            />

            <CustomInput name="location" 
                variant='standard' 
                label="Where are you located?" 
                placeholder={'Sweet home Alabama'}
                fullWidth 
                value={data.location}
                handleChange={(e)=>setData({
                    ...data,
                    location: e.target.value
                })}
            />

            <CustomInput name="website" 
                variant='standard' 
                label="Your website" 
                placeholder={'Free advertisement'}
                fullWidth 
                value={data.website}
                onChange={(e)=>setData({
                    ...data,
                    website: e.target.value
                })}
            />

            <Button variant='main' sx={{marginTop: '20px'}} onClick={onSubmit}>
                Save
            </Button>

            <Button variant='faint' sx={{marginTop: '20px'}} onClick={deleteProfile}>
                Delete Profile
            </Button>

        </Box>
    );
}


export default EditAll; 